export const ERR_MESSAGE = "Server error";
